import { Component, OnInit} from '@angular/core';
import { HomeService } from '../_services/home.service';
import { TopArticles } from '../_model/topArticles';
import Swal from 'sweetalert2';
import { browserRefresh } from '../app.component';
import { AuthenticationService } from '../_services';
import { GoogleAnalyticsService } from '../_services/google-analytics.service';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  chatActive: boolean=true;
  chatTopic:string;
  caseAlertMessage: string;
  alert: boolean=false;
  delayed: boolean = false ;
  topArticles: TopArticles = {};
  public browserRefresh: boolean;
  showAuthFailedNotification: boolean = false;
  authFailedMessage: string;
  disableLiveChatSHP: any;
  isSmartViewChat: any;

  constructor(private homeService: HomeService,private authService: AuthenticationService,private gaService : GoogleAnalyticsService) {
   this.getTopArticles();
   }

  ngOnInit() {
    this.gaService.updatePageName();
    this.homeService.sendMessage(true);
    let isSamlAuthFailed = this.authService.getValueInConfigFromLocalStorage('isSamlAuthFailed');
    let isCasAuthFailed = this.authService.getValueInConfigFromLocalStorage('isCasAuthFailed');
    if (isSamlAuthFailed === 'true') {
      let samlAuthFailType = this.authService.getValueInConfigFromLocalStorage('samlAuthFailType');
      let i18message = samlAuthFailType !== null && samlAuthFailType !== undefined && samlAuthFailType === 'config'
        ? JSON.parse(sessionStorage.getItem('i18n'))._value['shp.error.samlConfig']
        // ? "There is an issue with the Login configuration. Please contact your system administrator." 
        : JSON.parse(sessionStorage.getItem('i18n'))._value['shp.error.description'];

      this.authFailedMessage = i18message && i18message.length > 0 ? i18message : "Login Failed. Contact your administrator.";
      this.showAuthFailedNotification = true;
      this.authService.removeValueInConfigAtLocalStorage('isSamlAuthFailed');
      this.authService.removeValueInConfigAtLocalStorage('samlAuthFailType');
    } else if (isCasAuthFailed === 'true') {
      let i18message = JSON.parse(sessionStorage.getItem('i18n'))._value['shp.error.description'];
      this.authFailedMessage = i18message && i18message.length > 0 ? i18message : "Login Failed. Contact your administrator.";
      this.showAuthFailedNotification = true;
      this.authService.removeValueInConfigAtLocalStorage('isCasAuthFailed');
    }

    this.browserRefresh = browserRefresh;
    const userPk=this.authService.getCurrentUserPK();
    if(userPk==null){
      this.homeService.getShpLogin().subscribe(res=>{
      this.isSmartViewChat=res.return_body.is_smart_view_chat;
      this.disableLiveChatSHP = res.return_body.disable_live_chat_SHP
      if(res.return_body.isSHPLogin==false){
      this.homeService.getChatTimeOut().subscribe(res =>{
      console.log(res.return_body)
      setTimeout (()=>{ 
        let pk=this.authService.getCurrentUserPK();
        if (pk != null) {
          this.chatActive = false;
        }else{
          this.chatActive = true;
        }
      if(res.return_body.is_chat_invitation==true && this.chatActive && this.disableLiveChatSHP == false && this.isSmartViewChat==true){
          Swal.fire({
          allowOutsideClick: true,
          reverseButtons: true,
          showCancelButton: true,
          cancelButtonText: "No Thanks",
          confirmButtonText: "Chat",
          width:400,
          timer:res.return_body.auto_cancellation_time*1000,
          title:res.return_body.invitation_Message,
          position:'top-left',
          customClass: 'swal-wide chat',
          }).then((result) => {
          if (result.value) {
              this.homeService.openChat.next(true); 
          } 
          })
    }
  },res.return_body.delay_time*1000);
  this.homeService.sendMessage(false);
}, err => {
  this.homeService.sendMessage(false);
})}
this.homeService.sendMessage(false);
}, err => {
  this.homeService.sendMessage(false);
});
}
  setTimeout(() => {
    this.homeService.sendMessage(false);
  }, 2500);
}
    getTopArticles() {
    this.homeService.getTopArticles().subscribe(res => {
    this.topArticles = res.return_body;
  });
}
ngAfterViewInit() {
  this.caseMessage();
}

caseMessage(){
    this.caseAlertMessage = sessionStorage.getItem('alertMessage')
    if(this.caseAlertMessage){
      this.alert=true
    }
    setInterval(() => {
     this.delayed=true
     this.alert=false
     sessionStorage.removeItem('alertMessage')
    }, 5000);
  }

  closeAuthFailedNotification() {
    this.showAuthFailedNotification = false;
  }
}